import React from 'react'
import {
    Card,
    CardContent,
    Grid,
    Typography,
    withStyles
} from '@material-ui/core';
import Card2Style from './Card2Style'
import { ReactSVG } from 'react-svg';

const Card2 = (props) => {
    const { text, subtitle, image, altText, classes, svgLoader } = props;
    return (
        <Card md={3} className={classes.card}>
            <CardContent>
                <Grid container
                    direction="column"
                    alignItems="center"
                    justify="center">
                    <Grid item xs>
                        {svgLoader ? (
                            <div style={{height: '140px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <ReactSVG src={image} alt={altText} height="140" width="140" />
                            </div>
                        ) : (
                            <img src={image} alt={altText} className={classes.image} />
                        )}
                    </Grid>
                </Grid>

                <Grid container alignItems="center" direction={'column'}>
                    <Grid item xs className={classes.subtitleContainer}>
                        <Typography variant="h6" align="center">
                            <strong>{subtitle}</strong>
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography variant="body1" align="center">
                           {text}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default withStyles(Card2Style)(Card2);
